export const WOO_COMMERCE_CONVERSATION_PANEL_MODES = {
  INLINE: 'inline',
  SIDEBAR: 'sidebar',
};

export const buildWooCommerceStoreLabel = hook => {
  return (
    hook?.settings?.store_name ||
    hook?.store_name ||
    hook?.settings?.store_url ||
    hook?.reference_id ||
    'WooCommerce'
  );
};

export const buildWooCommerceConversationPanelMode = hook => {
  const value =
    hook?.conversation_panel_mode || hook?.settings?.conversation_panel_mode;

  return value === WOO_COMMERCE_CONVERSATION_PANEL_MODES.SIDEBAR
    ? WOO_COMMERCE_CONVERSATION_PANEL_MODES.SIDEBAR
    : WOO_COMMERCE_CONVERSATION_PANEL_MODES.INLINE;
};

export const hasWooCommerceConversationModeHooks = (hooks, mode) => {
  if (!(hooks || []).length) {
    return false;
  }

  return (hooks || []).some(
    hook => buildWooCommerceConversationPanelMode(hook) === mode
  );
};

export const isWooCommerceHookSelectionValid = (hooks, hookId) => {
  if (!hookId) {
    return true;
  }

  return (hooks || []).some(hook => String(hook.id) === String(hookId));
};

export const filterWooCommerceRecordsByConversationMode = (
  records,
  hooks,
  mode
) => {
  if (!mode) {
    return records || [];
  }

  const hookModes = new Map(
    (hooks || []).map(hook => [
      String(hook.id),
      buildWooCommerceConversationPanelMode(hook),
    ])
  );

  return (records || []).filter(record => {
    const hookMode =
      hookModes.get(String(record?.source_hook_id)) ||
      WOO_COMMERCE_CONVERSATION_PANEL_MODES.INLINE;

    return hookMode === mode;
  });
};

export const buildWooCommerceStoreOptions = hooks => {
  return (hooks || []).map(hook => ({
    id: String(hook.id),
    label: buildWooCommerceStoreLabel(hook),
    hook,
  }));
};

export const groupWooCommerceRecordsByStore = records => {
  const groups = new Map();

  (records || []).forEach(record => {
    const groupId = String(
      record?.source_hook_id || record?.source_reference_id || 'woocommerce'
    );
    const groupLabel =
      record?.source_label || record?.source_reference_id || 'WooCommerce';

    if (!groups.has(groupId)) {
      groups.set(groupId, {
        id: groupId,
        label: groupLabel,
        records: [],
      });
    }

    groups.get(groupId).records.push(record);
  });

  return Array.from(groups.values());
};
